import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconMapMarkerRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 10.401c0-3.044 2.298-5.4 5-5.4s5 2.356 5 5.4c0 1.277-.468 2.498-1.292 3.767-.831 1.28-1.979 2.54-3.265 3.906-.216.23-.337.356-.43.441l-.013.01-.012-.01a8.677 8.677 0 0 1-.431-.441c-1.287-1.365-2.434-2.627-3.265-3.907C7.468 12.9 7 11.678 7 10.402Zm5-7.4c-3.926 0-7 3.375-7 7.4 0 1.795.665 3.393 1.615 4.856.942 1.451 2.21 2.833 3.486 4.188l.023.024c.185.197.363.386.526.533.178.16.407.335.71.437.415.14.865.14 1.28 0a2.03 2.03 0 0 0 .71-.437c.163-.147.341-.336.526-.533l.023-.024c1.277-1.355 2.544-2.737 3.486-4.188C18.335 13.794 19 12.196 19 10.4 19 6.375 15.926 3 12 3Zm.001 8.998a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconMapMarkerRoundLine);
export default Memo;
